<div class="action-menu">
    @for (action of actions; track action.id) {
      @if (action.separator) {
        <div class="menu-separator"></div>
      }
      <button class="menu-item" [ngClass]="action.class" (click)="executeAction(action)">
        <lucide-icon [name]="action.icon" class="menu-icon"></lucide-icon>
        {{ action.label }}
      </button>
    }
</div>